// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fic-screen-btn-close {
  display: inline-block;
  color: var(--fi-color-white);
}
.fic-screen-btn-close .fa {
  color: var(--fi-color-white);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fic-screen/btn-close/fic-screen-btn-close.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,4BAAA;AACJ;AACI;EACI,4BAAA;AACR","sourcesContent":[".fic-screen-btn-close {\r\n    display: inline-block;\r\n    color: var(--fi-color-white);\r\n\r\n    .fa {\r\n        color: var(--fi-color-white);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
